"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaskPERCENT = function (value) {
  /**
   * Verifica se o valor possui apenas um caractere
   * e se sim, concatena com o número 0.
   */
  if (value.length === 1) {
    value = '0.0' + value;
  } else if (value.length === 0) {
    value = '0';
  }
  value = value.replace(',', '.');
  return parseFloat(value.replace(/[^\d]/g, '').replace(/(\d\d?)$/, '.$1')).toFixed(2).replace('.', ',');
};